import dayjs from "dayjs";

/**
 * A function to generate new "reset time duration", which is the duration that the user will have to wait before bein able to send another OTP
 *
 * @returns {number}
 */

export const getNewTime = () => {
  const triesCount = Number(localStorage.getItem("otpTries"));
  localStorage.setItem("otpTries", triesCount + 1);
  const newTime = triesCount >= 4 ? 300 : 60;
  const expiration = dayjs().add(newTime, "seconds").unix() * 1000;
  localStorage.setItem("otpExpiration", expiration);
  return newTime;
};

/**
 * A function that returns the remaining time until reset is avaliable from the previous attempt.
 * If that duration has already expired, or if none was found, it generates a new one and returns it.
 *
 * @returns {number}
 */

export const getRemainingExpiration = () => {
  const savedTime = Number(localStorage.getItem("otpExpiration"));
  if (!savedTime) {
    return getNewTime();
  }
  const prev = Math.min(dayjs(savedTime).diff(dayjs(), "seconds"), 1000);
  if (prev < 0) {
    return getNewTime();
  }
  return prev;
};

/**
 * A funciton to reset the state of otp
 */

export const resetExpiration = () => {
  localStorage.removeItem("otpExpiration");
  localStorage.removeItem("otpTries");
};
